import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {InitBackpainLevelPage} from "../init-backpain-level/init-backpain-level";
import {InitSummaryPage} from "../init-summary/init-summary";
import {InitWizardProvider} from "../../providers/init-wizard/init-wizard";

/**
 * Generated class for the InitBackpainTrackerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-init-backpain-tracker',
  templateUrl: 'init-backpain-tracker.html',
})
export class InitBackpainTrackerPage {

  constructor(public navCtrl: NavController, public navParams: NavParams, public initWizard: InitWizardProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InitBackpainTrackerPage');
  }

  goNext() {
    if(this.initWizard.backpainTracking) {
      this.navCtrl.push(InitBackpainLevelPage);
    } else {
      this.navCtrl.push(InitSummaryPage);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/init-backpain-tracker/init-backpain-tracker.ts